import { Selector, State } from "./types";
function createSelector(getState: () => State): Selector {
  return {
    isRemoveHolidayRequestFailure(holiday) {
      const state = getState().find(
        ({ holiday: { uuid } }) => holiday.uuid === uuid,
      );
      return state ? state.request.isFailure : false;
    },
    isRemoveHolidayRequestPending(holiday) {
      const state = getState().find(
        ({ holiday: { uuid } }) => uuid === holiday.uuid,
      );
      return state ? state.request.isPending : false;
    },
    isRemoveHolidayRequestSuccess(holiday) {
      const state = getState().find(
        ({ holiday: { uuid } }) => uuid === holiday.uuid,
      );
      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
